export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.7">
    <path fill="#D0E0E1" d="M0 12.6C0 5.6 5.6 0 12.6 0h53.8L100 34.2v91c0 6.9-5.6 12.5-12.6 12.5H12.6c-7 0-12.6-5.7-12.6-12.6V12.6z"/>
    <g fill="#6D7577">
        <path d="M19.5 89.1c2.5 0 4.4.6 5.7 1.9s1.9 3.1 1.9 5.4-.6 4.1-1.9 5.4c-1.3 1.3-3.2 1.9-5.7 1.9H12v10.1H8.7V89.1h10.8zM18.4 101c1.9 0 3.2-.4 4.1-1.1.9-.8 1.3-1.9 1.3-3.4s-.4-2.6-1.3-3.4c-.9-.8-2.2-1.2-4.1-1.2H12v9.1h6.4zM41.9 89.1c2.5 0 4.4.6 5.7 1.9s1.9 3.1 1.9 5.4-.6 4.1-1.9 5.4c-1.3 1.3-3.2 1.9-5.7 1.9h-7.5v10.1h-3.3V89.1h10.8zM40.8 101c1.9 0 3.2-.4 4.1-1.1.9-.8 1.3-1.9 1.3-3.4s-.4-2.6-1.3-3.4c-.9-.8-2.2-1.2-4.1-1.2h-6.4v9.1h6.4zM50.9 91.9v-2.8h19.7v2.8h-8.2v21.9h-3.3V91.9h-8.2zM71.1 89.1H75l6.2 9.6 6.4-9.6h3.7l-8.2 12 8.7 12.7h-4l-6.6-10.2-6.8 10.2h-3.7l8.6-12.7-8.2-12z"/>
    </g>
    <path fill="${fill ? fill : '#A1AFAF'}" d="M66.4 0v34.2H100L66.4 0z"/>
</svg>`
)



// WEBPACK FOOTER //
// ./components/Icon/icons/files/pptx.jsx